import Cards from "ab-cards";

const Experiencias = ({ classname, moduloCross, i18n }) => {
  let disfrute = moduloCross?.modCrossExperiencias;

  return (
    <Cards
      className={classname}
      title={
        i18n.language == "en"
          ? disfrute?.titleexperienciasen || disfrute?.titleexperiencias
          : i18n.language == "de"
          ? disfrute?.titleexperienciasde || disfrute?.titleexperiencias
          : disfrute?.titleexperiencias
      }
      cards={disfrute?.cardsexperiencias}
      text={disfrute?.textexperiencias}
      animated={disfrute?.animatedexperiencias}
      i18n={i18n}
    />
  );
};

export default Experiencias;
